import { Dialog, DialogTitle, DialogContent, SxProps } from "@mui/material"
import CloseIcon from "@mui/icons-material/Close"
import { ReactNode } from "react"
import { Theme } from "@mui/system"

interface OrevePopupProps {
    open: boolean
    handleClose?: () => void
    children: ReactNode
}

export const OrevePopup = ({
    open,
    handleClose,
    children,
}: OrevePopupProps) => {
    return (
        <>
            <Dialog
                open={open}
                maxWidth="md"
                PaperProps={{
                    sx: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        position: "absolute",
                        alignItems: "center",
                        textAlign: "center",
                        borderRadius: "20px",
                        py: "2.25rem",
                        px: "4.5rem",
                    },
                }}
            >
                {handleClose ? (
                    <CloseIcon
                        sx={{
                            position: "absolute",
                            right: "1rem",
                            top: "1rem",
                            color: "grey.500",
                            cursor: "pointer",
                            border: "2px solid",
                            borderColor: "transparent",
                            borderRadius: "5px",
                            transition:
                                "border-color 0.2s ease-in-out, color 0.2s ease-in-out",
                            "&:hover": {
                                borderColor: "grey.300",
                                color: "grey.600",
                            },
                        }}
                        onClick={handleClose}
                        data-testid="close-oreve-popup"
                        data-cy={"popup__close"}
                    />
                ) : null}
                {children}
            </Dialog>
        </>
    )
}

export const OrevePopupContent = ({ children, sx }: { children: ReactNode, sx?: SxProps<Theme> }) => {
    return (
        <DialogContent
            sx={{
                width: "100%",
                py: "0",
                px: "0",
                mt: "1.5rem",
                ...sx
            }}
        >
            {children}
        </DialogContent>
    )
}

export const OrevePopupTitle = ({ children }: { children: ReactNode }) => {
    return (
        <DialogTitle
            sx={{
                py: 0,
            }}
        >
            {children}
        </DialogTitle>
    )
}
